import React, { useEffect, useState } from "react";
import SaveButton from "../../../components/Buttons/SaveButton";
import SelectListField from "../../../components/Fields/SelectListField";
import { FormConfig } from "../../../components/Fields/Types";
import useSelectListOptions from "../../../components/Hooks/SelectListOptionsHook/useSelectListOptions";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import DataService from "../../../services/data.service";
import { LicensePopupProps } from "../../../types/PopupProps";
import { Result } from "../../../types/Result";

interface LicenseRegionModel {
    licenseId: number
    regionId: number
    included: boolean
    excluded: boolean
}

const AddRegionPopup: React.FC<LicensePopupProps> = ({ show, onHide, licenseId, included }) => {
    const [serverErrors, setServerErrors] = useState<Result>({ isSuccesful: true, messages: [] });
    const { handleResult, handleException } = useNotifications();

    const [formData, setFormData] = useState<LicenseRegionModel>({
        licenseId: licenseId,
        regionId: 0,
        included: included,
        excluded: !included
    });

    const regions = useSelectListOptions('api/v1/selectlist/RegionNameTrees', '-- Select region');

    useEffect(() => {
        formData.included = included;
        formData.excluded = !included;
        setFormData(formData);

    }, [included]);

    function submit() {
        if (formData) {
            DataService
                .create<LicenseRegionModel>(`api/v1/LicenseRegions`, formData)
                .then(response => {
                    handleResult(response);
                    setServerErrors(response);
                    if (response.isSuccesful === true) {
                        if (onHide)
                            onHide();
                    }
                })
                .catch(e => handleException(e));
        }
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'regionId', label: 'Region', labelSize: 2, validationRules: [{ type: 'isRequired' }] },
        ],
        handleSubmit: submit,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={included ? 'Include region in License' : 'Exclude region from License'}>
            <Popup.Body>
                <SelectListField {...getFieldProps('regionId')} options={regions} />
            </Popup.Body>
            <Popup.Footer>
                <SaveButton {...getSubmitButtonProps()} />
            </Popup.Footer>
        </Popup>
    );
}
export default AddRegionPopup;